var updatePartialView = require('utils/updatePartialView.js');

var $page;

// Listen for shop events
shop.on("baskethaschanged othertabbaskethaschanged", data => {
    //updateBasketPagePartialView(data);
    // mini basket is updated by the shared basket JS
});
shop.on("basketsummaryhaschanged", data => {
    updateBasketSummaryPartialView(data.BasketSummaryView);
    shop.sharedBasket.updateShippingPickerPartialView(data.ShippingPickerView);
});

shop.on('basketlinesandtotalhaschanged', data => {
    updateBasketPagePartialView(data);
});

shop.on("basketlinequantityhaschanged", (response) => {


});

// Page load
function pageLoad () {

    // Get the main wrapper
    $page = $(".basket-page");

    bindEvents();
}

function bindEvents ($scope = $page) {
    $scope = $($scope);

    bindhQuantity($scope);
    bindGetAnOffer($scope);
    shop.sharedBasket.bindRemoveFromBasket($scope);
    shop.sharedBasket.onShippingSelectChange($scope);
}

// Functionality methods
function updateQuantity (data = {}) {

    if (data.productid && data.quantity) {

        shop.sharedBasket.loading.show();

        var $poster = $.ajax({
            type: 'POST',
            url: shop.url.updateBasket,
            data: data
        });

        var updateContent = (content, httpCode) => {
            var $response = $('<div>').html(content);
            var miniBasket = $response.find('#MiniBasket').html();
            var basketLinesAndTotal = $response.find('#BasketLinesAndTotal').html();

            shop.on('baskethaschanged', miniBasket);
            shop.on('basketlinesandtotalhaschanged', basketLinesAndTotal);

            var messages = $response.find(".basketMessage");
            shop.sharedBasket.notifyAddedToBasket(messages);
        };

        $poster.then(function(response, codes) {
            //console.log(codes);
            updateContent(response);
        });

        $poster.fail(function(response) {
            updateContent(response);
        });

        $poster.always(shop.sharedBasket.loading.hide);
    }
}

function getAnOffer(message) {
    $zopim.livechat.say(message);
}

// DOM handeling methods
function updateBasketPagePartialView (outerHtml) {
    return updatePartialView({
        $el: $("#basket-page-content"),
        domEventName: "basket-page-content",
        outerHtml: outerHtml,
        ajax: {
            url: shop.url.basketPage
        }
    }).then(bindEvents);
}

function updateBasketSummaryPartialView (outerHtml) {
    return updatePartialView({
        $el: $("#basket-summary"),
        domEventName: "basket-summary",
        outerHtml: outerHtml,
        ajax: {
            url: shop.url.basketSummary
        }
    }).then(bindEvents);
}

// Event methods
function bindhQuantity (scope = document.body) {
    var $hQuantity = $(scope).find(".hQuantity").not("[data-binded]");
    $hQuantity.attr("data-binded", hLib.getTime());
    $hQuantity.hQuantity({
        onChange: function (val) {
            updateQuantity({
                productid: $(this).data("productid"),
                variantid: $(this).data("variantid"),
                quantity: val
            });
        }
    });
}


function bindGetAnOffer(scope = document.body) {
    $(scope).find(".btn-offer").hClick(function() {
        var message = $(this).data("message");
        getAnOffer(message);
    });
}


// Schedule pageload
shop.pageLoad(pageLoad);

// Public methods
module.exports = {
    updateQuantity,
    updateBasketPagePartialView,
    updateBasketSummaryPartialView

};